import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";

export const MusicPlayer = ({ url, colors, autoStart }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (autoStart && ref.current) {
      ref.current.volume = 0.4;
      ref.current
        .play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    }
  }, [autoStart, url]);

  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.volume = 0.4;
      a.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <>
      <audio ref={ref} src={url} loop preload="auto" />
      <motion.button
        data-testid="music-toggle-btn"
        onClick={toggle}
        className="fixed bottom-6 right-5 z-50 flex items-center justify-center rounded-full shadow-lg"
        style={{ width: 52, height: 52, background: colors.secondary, color: "#fff" }}
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.08 }}
        animate={playing ? { boxShadow: [`0 0 0 0 ${colors.secondary}55`, `0 0 0 12px ${colors.secondary}00`] } : {}}
        transition={{ duration: 1.6, repeat: playing ? Infinity : 0 }}
      >
        {playing ? <Volume2 size={22} /> : <VolumeX size={22} />}
      </motion.button>
    </>
  );
};
